var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'sp-price',
    {
      'line-through': _vm.lineThrough
    }
  ]},[_c('span',{staticClass:"symbol",style:({ 'font-size': (_vm.size + "px") })},[_vm._v(_vm._s(_vm.symbol))]),_c('span',{staticClass:"int-value",style:({ 'font-size': (_vm.size + "px") })},[_vm._v(_vm._s(_vm.intValue))])])}
var staticRenderFns = []

export { render, staticRenderFns }